<!--
Date: 2024-04-23
Desc: 设置未开户下页面顶部导航，为公共组件
 -->
<template>
    <div class="comp-step comp">
        <div class="nav-bar">
            <div
                v-for="(nav, index) in navs"
                :key="nav.val"
                :class="{ 'is-active': nav.active }"
                class="comp-step-item"
            >
                <div class="setp-content">
                    <span class="num">{{ index + 1 }}</span>
                    <span class="step-text">{{ nav.val }}</span>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: "NavBar",
    props: {
        navs: {
            type: Array,
            required: true
        }
    },
    data() {
        return {};
    },
    methods: {}
};
</script>
<style lang="scss">
.comp-step {
    .nav-bar {
        display: flex;
        justify-content: center;
        align-items: center;
        .comp-step-item {
            width: 290px;
            height: 40px;
            position: relative;
            margin-right: -10px;
            z-index: 0;

            &::before {
                content: "";
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
                background-color: #f0f2f5;
                clip-path: polygon(
                    0 0,
                    calc(100% - 20px) 0,
                    100% 50%,
                    calc(100% - 20px) 100%,
                    0 100%,
                    20px 50%
                );
                z-index: -1;
            }

            &:last-child {
                margin-right: 0;
            }
            .setp-content {
                position: absolute;
                display: flex;
                align-items: center;
                height: 56px;
                left: 50%;
                top: 50%;
                transform: translate(-50%, -50%);
                z-index: 10;
                .num {
                    width: 56px;
                    height: 56px;
                    border: 1px solid #ccc;
                    border-radius: 56px;
                    font-size: 26px;
                    text-align: center;
                    line-height: 56px;
                    color: #ccc;
                    background-color: #fff;
                }
                .step-text {
                    color: #999;
                    font-size: 18px;
                    font-weight: 500;
                    margin-left: 16px;
                    width: 95px;
                }
            }
        }
        .comp-step-item.is-active {
            z-index: 1;
            &::before {
                background-color: var(--color-primary);
            }
            .num {
                color: var(--color-primary);
                border: 1px solid var(--color-primary);
                font-weight: bold;
            }
            .step-text {
                color: #fff;
            }
        }
    }
}
</style>
